import { useDispatch } from "Hooks";
import { useCallback } from "react";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

const useErrorHandler = () => {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(setToastMsg("toastMsgs:something_went_wrong"));
  }, [dispatch]);
};

export default useErrorHandler;
